import React from 'react';

export default function FwEditIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-edit' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
